import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag, Table } from 'antd';
import { FileText, Eye } from 'lucide-react';
import dayjs from 'dayjs';
import { getContractType } from '../../../../utils/contractTypes';
import { StatusTag, IconAction, EmptyState, CollapsibleCard } from '../../../common';

function getStatusTag(contract) {
    if (!contract.active) return <StatusTag tone="neutral">Inactivo</StatusTag>;
    const isExpired = contract.expirationDate && dayjs(contract.expirationDate).isBefore(dayjs());
    return isExpired ? (
        <StatusTag tone="danger" dot>
            Expirado
        </StatusTag>
    ) : (
        <StatusTag tone="success" dot>
            Activo
        </StatusTag>
    );
}

export default function ClientContractsSection({ contracts }) {
    const navigate = useNavigate();
    const safeContracts = Array.isArray(contracts) ? contracts : [];

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <span className="text-sm font-medium text-surface-900">{text}</span>
        },
        {
            title: 'Tipo',
            dataIndex: 'type',
            key: 'type',
            render: (type) => {
                const t = getContractType(type);
                return (
                    <Tag color={t.color} className="!m-0">
                        {t.label}
                    </Tag>
                );
            }
        },
        {
            title: 'Vencimiento',
            dataIndex: 'expirationDate',
            key: 'expirationDate',
            render: (date) => <span className="text-sm text-surface-600 tabular-nums">{date ? dayjs(date).format('DD/MM/YYYY') : '—'}</span>
        },
        {
            title: 'Estado',
            key: 'status',
            render: (_, record) => getStatusTag(record)
        },
        {
            title: '',
            key: 'action',
            width: 64,
            align: 'right',
            render: (_, record) => (
                <IconAction icon={<Eye />} label="Ver contratación" onClick={() => navigate(`/dashboard/trade/contracts/contract?id=${record._id}`)} />
            )
        }
    ];

    return (
        <CollapsibleCard flush
            icon={<FileText />}
            iconTone="violet"
            title="Contrataciones"
            count={`${safeContracts.length} ${safeContracts.length === 1 ? 'contratación' : 'contrataciones'}`}
            countTone="violet">
            {safeContracts.length > 0 ? (
                <Table dataSource={safeContracts} columns={columns} rowKey="_id" pagination={false} size="middle" scroll={{ x: 560 }} />
            ) : (
                <EmptyState icon={<FileText />} title="Sin contrataciones" description="No hay contratos activos para este cliente" className="!py-8" />
            )}
        </CollapsibleCard>
    );
}
